module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAVCAYAAAAuJkyQAAAABHNCSVQICAgIfAhkiAAAAOVJREFUSInN1j0OgzAMBeBHQeJKsORMMMMIM5yJpb1RG6lVO5SfEFJI7BDVCxFC8ic/SySSj/sbf1SX6fC8DZBdExyg900AQHYNZN/OL9OyDoJR+8a5QJKJ74TiXCwf9W2QSelDeF0HAGNkSSaQFlUw1CaRoppTmXcoLesgqD3MChQCdYTZgM5E2WCMoDNQtpifIJ8oF8wuyAfKFXMI4qAoGCsQBUXFWINcUByME8gGxcUA48/VFTVh1Kd+pmAAIKLeh/RpqEXFAI6RrZpq8fnAsEAmFBcDEHbIhAKWCxa3yDt0Vn0AFXbGYeX3+LYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/img14.png
// module id = Ej8y
// module chunks = 1